module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "triangle",
    style: (_vm.customStyle)
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62ea3c6a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/triangle/Triangle.vue
// module id = 1337
// module chunks = 1